import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import { type Config, type ConfigState } from "./types";

const initialState: ConfigState = {
	configLoaded: false,
};

export const configSlice = createSlice({
	name: "config",
	initialState,
	reducers: {
		setConfigs: (state, { payload: config }: PayloadAction<Config>) => {
			state.configLoaded = true;
			state.apiBaseUrls = config.API_BASE_URLS;
			state.b2c = config.B2C;
			state.unleash = config.UNLEASH;
			state.application = config.APPLICATION;
			state.applicationId = config.GOS_APPLICATION_ID;
			state.matomo = config.MATOMO;
		},
	},
});

export const { setConfigs: setConfigs } = configSlice.actions;
